import { render, staticRenderFns } from "./PlaceMenu.vue?vue&type=template&id=4b0625d8&scoped=true&"
import script from "./PlaceMenu.vue?vue&type=script&lang=js&"
export * from "./PlaceMenu.vue?vue&type=script&lang=js&"
import style0 from "./PlaceMenu.vue?vue&type=style&index=0&id=4b0625d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0625d8",
  null
  
)

export default component.exports